export default "__VITE_ASSET__4e8d7f51__"